<template>
  <v-dialog
    v-model="dialog"
    max-width="850px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Liedersuche</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-tabs-items v-model="side">
            <v-tab-item>
              <v-toolbar elevation="0">
                <v-spacer />
                <v-text-field
                  style="max-width: 250px"
                  v-model="search"
                  append-icon="mdi-magnify"
                  @click:append="searchSongs"
                  v-on:keyup.enter="searchSongs"
                  label="Suchen"
                  single-line
                  hide-details
                />
              </v-toolbar>
              <div class="text-center" v-if="loading">
                <v-progress-circular
                  class="my-15"
                  :size="50"
                  color="primary"
                  indeterminate
                />
              </div>
              <v-list style="max-height: 600px" class="overflow-y-auto" v-else>
                <v-list-item
                  v-for="song in songs"
                  :key="song.id"
                  @click="goToSong(song.gl_number)"
                >
                  <v-list-item-avatar color="primary" size="40">
                    <span class="white--text text-h6">
                      {{ song.gl_number }}
                    </span>
                  </v-list-item-avatar>
                  <v-list-item-content class="ml-3">
                    <v-list-item-title class="text-h6">
                      {{ song.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ song.author_info }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon>
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <div class="text-center">
                <v-progress-circular
                  v-if="loading"
                  class="my-15"
                  :size="50"
                  color="primary"
                  indeterminate
                />
              </div>
              <div v-if="!loading">
                <v-list-item elevation="0">
                  <v-btn icon @click="switchSide">
                    <v-icon>
                      mdi-chevron-left
                    </v-icon>
                  </v-btn>
                  <v-avatar color="primary" size="40">
                    <span class="white--text text-h6">
                      {{ currentlyShowedSong.gl_number }}
                    </span>
                  </v-avatar>
                  <v-list-item-content class="ml-3">
                    <v-list-item-title class="text-h6">
                      {{ currentlyShowedSong.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ currentlyShowedSong.author_info }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div
                  v-html="currentlyShowedSong.full_text"
                  style="max-height: 600px"
                  class="overflow-y-auto"
                />
                <div
                  class="text-right text-caption mr-4"
                  v-if="currentlyShowedSong.copyright_info"
                >
                  © {{ currentlyShowedSong.copyright_info }}
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" elevation="0" @click="closeDialog">
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import projectMixin from "@/mixins/projectMixin"

import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const SongsRepository = RepositoryFactory.get("songs")

export default {
  name: "DialogSongs",
  props: {
    dialog: Boolean,
  },
  mixins: [projectMixin],
  data() {
    return {
      songs: [],
      side: 0,
      sides: ["list", "text"],
      search: "",
      currentlyShowedSong: {},
      loading: false,
    }
  },
  async created() {
    this.loading = true
    const { data } = await SongsRepository.get()
    this.songs = data
    this.loading = false
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog")
      this.search = ""
      this.searchSongs()
      this.side = 0
      this.currentlyShowedSong = {}
    },
    switchSide() {
      if (this.side == 0) {
        this.side = 1
      } else {
        this.side = 0
      }
    },
    async searchSongs() {
      let { data } = await SongsRepository.getBySearch(this.search)
      this.songs = data
    },
    async goToSong(goTo) {
      this.side = 1
      this.loading = true
      const { data } = await SongsRepository.getByNumber(goTo)
      this.currentlyShowedSong = data
      this.loading = false
    },
  },
}
</script>
